import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { CoreAuthService } from '@core/auth/services/core-auth-service'
import { SignalrService } from '@core/websockets/signalr/services/signalr.service'
import { SocketService } from '@sockets/services/socket.service'
import { FACTORY_TOKEN } from '@core/websockets/signalr/constants/signalr.constants'
import { SignalrFactory } from '@core/websockets/signalr/factories/signalr.factory'

export function provideWebSockets(): EnvironmentProviders {
  return makeEnvironmentProviders([
    SignalrService,
    SocketService,
    {
      provide: FACTORY_TOKEN,
      useFactory: SignalrFactory,
      deps: [CoreAuthService, HttpClient]
    }
  ])
}
